export function toIsoDate(date: Date): string {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Converts local calendar YYYY-MM-DD bounds to absolute UTC ISO strings
 * for deleted-items API filters (start/end of each local day).
 */
export function toDeletedRangeIso(
  fromYmd?: string,
  toYmd?: string,
): { deletedFrom?: string; deletedTo?: string } {
  const deletedFrom = fromYmd?.trim()
    ? localDayBoundIso(fromYmd.trim(), 'start')
    : undefined;
  const deletedTo = toYmd?.trim()
    ? localDayBoundIso(toYmd.trim(), 'end')
    : undefined;
  return {
    ...(deletedFrom ? { deletedFrom } : {}),
    ...(deletedTo ? { deletedTo } : {}),
  };
}

function localDayBoundIso(
  ymd: string,
  bound: 'start' | 'end',
): string | undefined {
  const local = fromIsoDate(ymd);
  if (!local) {
    return undefined;
  }
  if (bound === 'start') {
    local.setHours(0, 0, 0, 0);
  } else {
    local.setHours(23, 59, 59, 999);
  }
  return local.toISOString();
}

export function formatDisplayDate(date: Date): string {
  const day = `${date.getDate()}`.padStart(2, '0');
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  return `${day}/${month}/${date.getFullYear()}`;
}

export function fromIsoDate(value: string): Date | null {
  if (!value) {
    return null;
  }

  const date = new Date(`${value}T00:00:00`);
  return Number.isNaN(date.getTime()) ? null : date;
}
